export const appConfig = {
	enableWidget: true,
	iconPrimaryColor: "#155eef",
	svgSettings: {
		buttonPosition: "bottom-right",
		buttonPositionMobile: "bottom-right",
		exactPosition: {
			enabled: true,
			horizontalOffset: "24",
			verticalOffset: "24",
			horizontalDirection: "left",
			verticalDirection: "higher",
		},
	},
};
